module.exports = __webpack_public_path__ + "static/img/yh.94dbeee4.gif";